import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';
import {
  calculateFencePailing,
  calculateFencePicket,
} from "src/utils/formulas/fence";
import {useEffect} from "react";

export const usePresenter = () => {

  const { dispatch, fenceStore } = useStoreon<IState, IEvents>('fenceStore');

  useEffect(() => {
    if (fenceStore.fenceType === 'picket') {
      const {
        pCalc, // П - Длина штакетника
        kpCalc, // КП - количество пролетов
        sCalc, // С - количество столбов
        dsCalc, // ДС - длина столбов
        mCalc, // М - количество саморезов
        nCalc, // Н - длина направляющих
      } = calculateFencePicket(
        fenceStore.dzValue || 0, // ДЗ - длина забора
        fenceStore.vzValue, // ВЗ - высота забора
        fenceStore.tpValue, // ТП - тип периметра
        fenceStore.rsValue || 0, // РС - расстояние между столбами
        fenceStore.kvValue, // КВ - количество ворот
        fenceStore.shvValue, // ШВ - ширина ворот
        fenceStore.kkValue, // КК - количество калиток
        fenceStore.shkValue, // ШК - ширина калитки
        fenceStore.pgkValue, // ПГК - параметр горизонталей количество
        fenceStore.fenceColor, // Цвет штакетника
        fenceStore.picketType, // Вид штакетника
      );

      dispatch('fence/set-p-calc', { pCalc });
      dispatch('fence/set-kp-calc', { kpCalc });
      dispatch('fence/set-s-calc', { sCalc });
      dispatch('fence/set-ds-calc', { dsCalc });
      dispatch('fence/set-m-calc', { mCalc });
      dispatch('fence/set-n-calc', { nCalc });
    }

    if (fenceStore.fenceType === 'pailing') {
      const {
        pCalc, // П - количество штакетника
        kpCalc, // КП - количество пролетов
        sCalc, // С - количество столбов
        dsCalc, // ДС - длина столбов
        mCalc, // М - количество саморезов
        nCalc, // Н - длина направляющих
        kppCalc, // КПП - количество П-планок
      } = calculateFencePailing(
        fenceStore.dzValue || 0, // ДЗ - длина забора
        fenceStore.vzValue, // ВЗ - высота забора
        fenceStore.tpValue, // ТП - тип периметра
        fenceStore.rsValue || 0, // РС - расстояние между столбами
        fenceStore.kvValue, // КВ - количество ворот
        fenceStore.shvValue, // ШВ - ширина ворот
        fenceStore.kkValue, // КК - количество калиток
        fenceStore.shkValue, // ШК - ширина калитки
        fenceStore.pgkValue, // ПГК - параметр горизонталей количество
        fenceStore.pailingType, // Вид профнастила
      );

      dispatch('fence/set-p-calc', { pCalc });
      dispatch('fence/set-kp-calc', { kpCalc });
      dispatch('fence/set-s-calc', { sCalc });
      dispatch('fence/set-ds-calc', { dsCalc });
      dispatch('fence/set-m-calc', { mCalc });
      dispatch('fence/set-n-calc', { nCalc });
      dispatch('fence/set-kpp-calc', { kppCalc });
    }
  }, [
    dispatch,
    fenceStore.fenceType,
    fenceStore.fenceColor,
    fenceStore.dzValue, // ДЗ - длина забора
    fenceStore.vzValue, // ВЗ - высота забора
    fenceStore.tpValue, // ТП - тип периметра
    fenceStore.rsValue, // РС - расстояние между столбами
    fenceStore.ssValue, // сечение столба
    fenceStore.pCalc, // П - количество листов профнастила
    fenceStore.sCalc, // С - количество столбов
    fenceStore.dsCalc, // ДС - длина столбов
    fenceStore.mCalc, // М - количество саморезов
    fenceStore.nCalc, // Н - длина направляющих
    fenceStore.kvValue, // КВ - количество ворот
    fenceStore.shvValue, // ШВ - ширина ворот
    fenceStore.kkValue, // КК - количество калиток
    fenceStore.shkValue, // ШК - ширина калитки
    fenceStore.kpCalc, // КП - количество пролетов
    fenceStore.kppCalc, // КПП - количество П-планок
    fenceStore.pgvValue, // ПГВ - параметр горизонталей вид
    fenceStore.pgkValue, // ПГК - параметр горизонталей количество
    fenceStore.kValue, // крепления
    fenceStore.pailingCoating, // Параметры профнастила - Тип покрытия
    fenceStore.pailingType, // Параметры профнастила - Вид профнастила
    fenceStore.pailingPBar, // Параметры профнастила - П-образная планка
    fenceStore.picketCoating, // Параметры штакетника - Тип покрытия
    fenceStore.picketType, // Параметры штакетника - Вид штакетника
  ])

  const resultHandler = () => {
    dispatch('fence/set-modal-is-open', { modalIsOpen: true });
  };

  return {
    totalPrice:  fenceStore.totalPrice,
    resultHandler,
  };
};
